var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 495 495",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EE8700"
    },
    points: "247.5,0 247.5,40 455,40 455,455 247.5,455 247.5,495 495,495 495,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF9811"
    },
    points: "40,455 40,40 247.5,40 247.5,0 0,0 0,495 247.5,495 247.5,455  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M239.609,255.922c0,0-17.226-33.158-16.579-57.446c0.464-17.292,39.508-34.451,54.86-59.32 C293.241,114.221,276.016,90,276.016,90s3.813,17.872-6.416,36.39c-10.163,18.453-47.863,29.345-62.553,61.26 C192.408,219.581,239.609,255.922,239.609,255.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M304.117,155.088c0,0-58.739,22.332-58.739,47.847c0,25.582,15.932,33.871,18.519,42.16 c2.536,8.29-4.46,22.349-4.46,22.349s22.978-15.999,19.099-34.451c-3.813-18.519-21.702-24.289-11.457-42.807 C273.943,177.818,304.117,155.088,304.117,155.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M233.275,289.66c54.263-1.939,74.008-19.049,74.008-19.049 c-35.097,9.583-128.288,8.936-128.934,1.94c-0.647-7.046,28.698-12.816,28.698-12.816s-45.924,0-49.737,11.522 C153.481,282.73,178.995,291.6,233.275,289.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M311.76,316.601c0,0,53.103-11.34,47.863-40.22c-6.35-35.098-43.403-15.286-43.403-15.286 s26.178,0,28.698,15.932C347.504,292.959,311.76,316.601,311.76,316.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M285.598,301.249c0,0-13.412,3.564-33.224,5.769c-26.559,2.968-58.739,0.647-61.259-3.829 c-2.537-4.46,4.459-7.063,4.459-7.063c-31.931,7.709-14.44,21.056,22.929,23.642c32.113,2.205,79.844-9.583,79.844-9.583 L285.598,301.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M203.284,329.168c0,0-14.506,0.381-15.352,8.025c-0.846,7.642,8.936,14.506,44.68,16.578 c35.761,2.139,60.812-9.715,60.812-9.715l-16.115-9.848c0,0-10.23,2.139-25.98,4.277c-15.734,2.139-48.046-1.691-49.339-4.659 C200.698,330.842,203.284,329.168,203.284,329.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M226.66,383.63c76.545-0.066,110.234-14.059,115.738-20.011c5.504-5.968-1.758-10.627-1.758-10.627 s2.586,2.985-0.779,6.35c-3.432,3.432-34.518,11.921-84.321,14.44c-49.737,2.586-103.801-4.659-105.493-11.008 c-1.69-6.416,27.654-11.522,27.654-11.522c-3.366,0.447-44.233,1.292-45.526,12.367C130.884,374.694,150.048,383.63,226.66,383.63z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9811"
    },
    d: "M312.606,388.736c-33.622,6.747-135.748,2.47-135.748,2.47s66.382,15.8,142.148,2.586 c36.208-6.35,38.281-23.84,38.281-23.84S346.211,381.873,312.606,388.736z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.87d9bd52f93e66c5940cdde616007612.svg";
export { ForwardRef as ReactComponent };